import NewBusinessEducatorInformation from '@/components/purchase_policy/NewBusinessEducatorInformation.vue'
import NewBusinessAddress from '@/components/purchase_policy/NewBusinessAddress.vue'
import NewBusinessRegisteredService from '@/components/purchase_policy/NewBusinessRegisteredService.vue'
import NewBusinessBusinessExemption from '@/components/purchase_policy/NewBusinessBusinessExemption.vue'
import NewBusinessCoverPackages from '@/components/purchase_policy/NewBusinessCoverPackages.vue'
import NewBusinessGSTEligibility from '@/components/purchase_policy/NewBusinessGSTEligibility.vue'
import NewBusinessPolicyTerm from '@/components/purchase_policy/NewBusinessPolicyTerm.vue'
import NewBusinessFDALegalService from '@/components/purchase_policy/NewBusinessFDALegalService.vue'
import NewBusinessQuestionSets from '@/components/purchase_policy/NewBusinessQuestionSets.vue'
import NewBusinessSummary from '@/components/purchase_policy/NewBusinessSummary.vue'
import PurchaseOnlineInfo from '@/components/purchase_policy/PurchaseOnlineInfo.vue'


export default {
    components: {
        NewBusinessEducatorInformation,
        NewBusinessAddress,
        NewBusinessRegisteredService,
        NewBusinessBusinessExemption,
        NewBusinessCoverPackages,
        NewBusinessGSTEligibility,
        NewBusinessPolicyTerm,
        NewBusinessFDALegalService,
        NewBusinessQuestionSets,
        NewBusinessSummary,
        PurchaseOnlineInfo
    },
    data() {
        return {

            // baseURL: window.location.origin, //window.location.origin,

            previousPolicies: null,
            existingClaims: null,
            previousClaims: null,
            nswSmallBusinessExemption: null,

            previousPoliciesAnswer: null,
            previousClaimsAnswer: null,
            existingClaimsAnswer: null,

            sessionID: null,

            quoteReferenceId: this.$route.params.quote_reference_id,
            companyDetails: null,
            paymentTerms: null,

            previousPoliciesQuestion: `Has any insurer ever cancelled, declined, refused to <br /> renew or imposed special conditions on any of your insurance?`,
            previousPoliciesSubmitted: false,
            existingClaimsQuestion: `Are you aware of any circumstances that may result in a claim under the insurance policies  <br /> you are applying for or are you aware of any impending infringement notice or fine under the Education and <br /> Care Services National Law or any other relevant Act?`,
            existingClaimsSubmitted: false,
            previousClaimsQuestion: `During the last 5 years have any claims been made or threatened against you that <br /> might have been insured under the insurance policies you are applying for?`,
            previousClaimsSubmitted: false,
        
            nswSmallBusinessExemptionQuestion: `Are you a small business as defined in section 259A of the Duties Act 1997 (the Act) for the purposes of the small business exemption in section 259B of the Act?`,
            nswSmallBusinessExemptionAdditionalText: `
            <p>The definition of small business used in the amended Duties Act 1997 is the one used on the Tax Assessment Act 1997.</p>

            <p>* Aggregated turnover is your annual turnover plus the annual turnovers of any business entities that are your affiliates or are connected with you.</p>

            <p>For more information, visit the Revenue NSW website.</p>
            `
        }
    },
    computed: {
        
        fetchSessionDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    target: 'session_by_reference_id',
                    id: this.quoteReferenceId,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchQuoteDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    target: 'quote_by_session_id',
                    session_id: this.$store.state.sessionDetails.id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchPreviousPolicyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_policies_by_policy_id.json`,
                params: {
                    id: this.$store.state.sessionDetails.properties.previous_policy_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }
        },
        fetchCompanyDetailsPayload() {
            return {
                method: 'get',
                url: `${this.baseURL}/main/get_company.json`,
                params: {
                    id: this.$store.state.previousPolicyDetails.properties.company_id,
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth'
                }
            }   
        },

        publicLiabilityString() {
            return Number(this.$store.state.quoteDetails.properties.output_pl_base) > 0 ? `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$${this.$store.state.quoteDetails.properties.loi.replace("M", ",000,000")}` : `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },
        personalAccidentString() {
            return this.$store.state.sessionDetails.properties.include_personal_accident ? `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$30,000` : `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },
        legalAssistanceString() {
            return Number(this.$store.state.quoteDetails.properties.tl_addon_base) > 0 ?
            `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$${this.dbToString(this.$store.state.quoteDetails.properties.tl_addon_base)} + GST` :
            `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },
        debtRecoveryString() {
            return Number(this.$store.state.quoteDetails.properties.dr_addon_base) > 0 ?
            `<span class='icon-check-circle' style='color: #37B68F;'></span>&nbsp;$${this.dbToString(this.$store.state.quoteDetails.properties.dr_addon_base)} + GST` :
            `<span class='icon-cancel' style='color: #DA6868;'></span>`;
        },

        riskAddressString() {
            return (this.riskAddress.address2 !== "")
            ? `${this.riskAddress.address1}<br/>${this.riskAddress.address2}<br/>${this.riskAddress.suburb} ${this.riskAddress.state} ${this.riskAddress.postcode}`
            : `${this.riskAddress.address1}<br/>${this.riskAddress.suburb} ${this.riskAddress.state} ${this.riskAddress.postcode}`
        },
        mailingAddressString() {
            return (this.mailingAddress.address_2 !== "")
            ? `${this.mailingAddress.address_1}<br/>${this.mailingAddress.address_2}<br/>${this.mailingAddress.suburb} ${this.mailingAddress.state} ${this.mailingAddress.postcode}`
            : `${this.mailingAddress.address_1}<br/>${this.mailingAddress.suburb} ${this.mailingAddress.state} ${this.mailingAddress.postcode}`
        },

        summaryData() {
            return [
                { "Package": this.$store.state.sessionDetails.properties.package },
                { "Start date": this.$options.filters.formatDate(this.$store.state.sessionDetails.properties.policy_start) },
                { "Expiry Date": this.$options.filters.formatDate(this.$store.state.sessionDetails.properties.policy_expiry) },
                { "<h1>Cover</h1>": "&nbsp;" },
                { "Public Liability": this.publicLiabilityString },
                { "Personal Accident": this.personalAccidentString },
                { "Legal Assistance": this.legalAssistanceString },
                { "Debt Recovery": this.debtRecoveryString },
                { "&nbsp;": "&nbsp;" },
            ]
        },

        membershipBreakdown() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base_gst)).toFixed(2);
        },
        publicLiabilityPremiumBreakdown() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base_gst)).toFixed(2);
        },
        personalAccidentPremiumBreakdown() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base_gst)).toFixed(2);
        },
        legalServices() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base_gst)).toFixed(2);
        },
        activitiesPremium() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.activities_prorated_premium)).toFixed(2);
        },
        additionalBranchesPremium() {
            return (this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_base) + this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_base_gst)).toFixed(2);
        },
        brokerFee() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.activities_broker_fee)
            ).toFixed(2);
        },
        stampDuty() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_stamp_duty) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_stamp_duty) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_stamp_duty)
            ).toFixed(2);
        },
        totalGSTIncluded() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base_gst) +
                ((Number(this.$store.state.quoteDetails.properties.activities_total_premium / 100) / 1.1) * 0.10) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_broker_gst)
            ).toFixed(2);
        },
        totalPayableBase() {
            return (
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_membership_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.addons_base_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.additional_branches_total_fee) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_broker_gst) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.activities_total_premium) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pa_stamp_duty) +
                this.dbToNumber(this.$store.state.quoteDetails.properties.output_pl_stamp_duty)
            ).toFixed(2);
        },
        totalPayable() {
            const _totalpayable = 1000;
            return _totalpayable.toFixed(2);           
        },
        interestPremiumFunding() {
            switch(this.paymentTerms) {
                case 'annual':
                    return 0;

                case 'monthly':
                case 'fortnightly':
                    return (Number(this.totalPayable) * 0.10).toFixed(2);
            }
        },
        async premiumBreakdownData() {
            let array = [
                { "Membership": `$${this.membershipBreakdown}` },
                { "Public Liability Premium": `$${this.publicLiabilityPremiumBreakdown}` },
                { "Personal Accident Premium": `$${this.personalAccidentPremiumBreakdown}` },
                { "&nbsp;": "&nbsp;" },
                { "FDCA Legal Services": `$${this.legalServices}` }
            ];

            if(Number(this.activitiesPremium) > 0) {
                array.push({ "Activities Premium": `$${this.activitiesPremium}` });
            }

            if(Number(this.additionalBranchesPremium) > 0) {
                array.push({ "Additional Branches Premium": `$${this.additionalBranchesPremium}` });
            }
            array.push({ "&nbsp;": "&nbsp;" });
            array.push({ "FDCA Broker Fee": `$${this.brokerFee}` });
            array.push({ "Stamp Duty": `$${this.stampDuty}` });
            
            if(this.paymentTerms !== 'annual') {
                array.push({ "Interest - Premium Funding": `$${this.interestPremiumFunding}` });
            }
            
            array.push({ "&nbsp;": "&nbsp;" });
            array.push({ "Total GST Included": `$${this.totalGSTIncluded}` });
            array.push({ "TOTAL PAYABLE": `$${this.totalPayable}` });

            return array;
        },
        
        policyHolderInformationData() {
            return [
                { "Member Number": this.$store.state.previousPolicyDetails.properties.member_no },
                { "Insured Name": this.$store.state.sessionDetails.properties.insured_name },
                { "Dual Educator": this.dualEducator },
                { "Risk Address": this.riskAddressString },
                { "Mailing Address": this.mailingAddressString },
                { "Registered Service": this.registeredService.service_name },
                { "&nbsp;": "&nbsp;" },
            ];
        },
        dualEducator() {
            let dualEduatorObject = JSON.parse(this.$store.state.sessionDetails.properties.dual_educators);
            return Object.keys(dualEduatorObject).length > 0 ? `${dualEduatorObject.first_name} ${dualEduatorObject.last_name}` : "";
        },
        riskAddress() {
            return JSON.parse(this.$store.state.sessionDetails.properties.insured_address);
        },
        mailingAddress() {
            return (this.$store.state.companyDetails.fdca_address.length > 0) ?
            this.$store.state.companyDetails.fdca_address[0].properties :
            [];
        },
        registeredService() {
            return JSON.parse(this.$store.state.companyDetails.fdca_company[0].properties.service);
        },
        eligibleForRenewal() {
            let policyExpiry = this.$store.state.previousPolicyDetails.properties.policy_expiry,
            eligibleRenewalDate = moment(policyExpiry).subtract('days', 45),
            isEligible = moment().isAfter(eligibleRenewalDate);

            if (this.previousPolicies || this.existingClaims || this.previousClaims){
                return false;
            } else {
                return true;
            }
        }
    },
    methods: {
        formatPayload(key, values, index) {
            let toFormat = ['addresses', 'insured_address', 'mailing_address', 'relief_educators', 'activities', 'dual_educators', 'registered_service', 'additional_branches', 'interested_parties'];

            if(key == "insured_address"){
                let temp_insured_address = values[index];
                let check_address = "address" in temp_insured_address;
         
                if(check_address == true ){
                    values[index] = temp_insured_address.address;
                }         
            }
            
            let formattedString = values[index] ? JSON.stringify(JSON.stringify(values[index])) : '';
            let data = values[index];
            
            if (toFormat.indexOf(key) >= 0 && formattedString)
                data = formattedString.substring(1, formattedString.length - 1);
            return data;
        },
        createPayloadStructureAndStringify(fields) { 
            let payload = { 
                properties: {} 
            } 
            const values = Object.values(fields); 
            const keys = Object.keys(fields); 
 
            keys.forEach((item, i) => { 
 
                if (typeof values[i] === "boolean"){
                    payload.properties[keys[i]] = values[i] ? "true": "false" 
                } else {
                    payload.properties[keys[i]] = this.formatPayload(keys[i], values, i);
                }
             
            }); 

            payload.properties.outstanding_claims = payload.properties.existing_claims
            let registeredService = payload.properties
                .registered_service
                .replace(/\\/gm, '')

            if(!!registeredService){
                const parsedRegisteredService = JSON.parse(registeredService)
                payload.properties.acecqa_id = !!parsedRegisteredService.id ? parsedRegisteredService.id : "-1";
            }

            delete payload.properties.existing_claims
            delete payload.properties.additional_cover_code
            
            delete payload.properties.endorsement_id
            delete payload.properties.pl_limit
            delete payload.properties.coordination_unit
            delete payload.properties.amount_exceed_flag
            delete payload.properties.terms_agreement_flag
            delete payload.properties.last_step
            delete payload.properties.qualified_flag
            delete payload.properties.abandon_log_flag
            delete payload.properties.is_deleted
            delete payload.properties.evidence_of_insurance_url
            delete payload.properties.financial_services_guide_url
            delete payload.properties.letter_of_cancellation_url
            delete payload.properties.official_receipt_and_tax_invoice_url
            delete payload.properties.customer_id
            delete payload.properties.generate_insurance_docs
            delete payload.properties.generate_membership_doc
            delete payload.properties.generate_cancellation_docs
            delete payload.properties.email_insurance_docs
            delete payload.properties.email_membership_doc
            delete payload.properties.email_cancellation_docs
            delete payload.properties.due_for_renewal
            console.groupEnd();
            return payload; 
        },
        generateQuoteReferenceId(length) {
            let result = '',
                characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
                charactersLength = characters.length;
            for (let i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result.toUpperCase();
        },
        getSessionPayload($method) {
            let formattedSession = this.createPayloadStructureAndStringify(this.$store.state.sessionDetails.properties);
            formattedSession.mailing_address = formattedSession.properties.mailing_address;
            delete formattedSession.properties.mailing_address;
            formattedSession.env = this.environment;

            if($method === "create") {
                formattedSession.properties.session_quote_reference_id = this.generateQuoteReferenceId(10);
                this.$store.commit('mutate', {
                    property: "sessionDetails.properties.session_quote_reference_id",
                    value: formattedSession.properties.session_quote_reference_id
                });
            }
            
            formattedSession.id = ($method === "create")
            ? -1 //for create
            : this.sessionID;
            formattedSession.properties.include_membership = true;
            formattedSession.properties.include_personal_accident = true;
            formattedSession.properties.policy_status = "active";
            formattedSession.properties.session_status = "draft";
            formattedSession.properties.transaction_type = "New Policy";
            formattedSession.properties.amendment_description = "New Policy";
            formattedSession.properties.policy_type = (formattedSession.properties.user_type === "educator") ? "Individual Educator" : "Schema";
            return formattedSession;
        },
        createUpdateSession($origin) {
            if (this.isInvalid(this.sessionID)){
                this.createSession($origin);
            } else {
                this.updateSession($origin);
            }

        },
        async createSession($origin) {
            let payload = {
                method: 'post',
                url: `${this.baseURL}/api/fdca/cfw/session/create_update.json`,
                data: this.getSessionPayload("create")
            },
            response = await this.$store.dispatch('fetchData', payload);
            if(response.status == 200) {
                this.sessionID = response.data.items.id;
                localStorage.setItem("session_id", response.data.items.id);
                this.updateSession($origin, true); // update policy number, can only be called after creating session as session id is needed

                if($origin === 'registered-service') {
                    if(this.$store.state.NewBusinessHasValidNSWAddressAndAssignedToRisk) { //jump to 2nd next routes
                        this.$store.commit('mutate', {
                            property: "NewBusinessStep",
                            value: this.$store.state.NewBusinessStep + 1
                        });
                    } else {
                        this.$store.commit('mutate', {
                            property: "NewBusinessStep",
                            value: this.$store.state.NewBusinessStep + 2
                        });
                    } 

                } else {
                    // localStorage.setItem("business_step", (this.$store.state.NewBusinessStep - 1));
                    this.$store.commit('mutate', {
                        property: "NewBusinessStep",
                        value: this.$store.state.NewBusinessStep + 1
                    });

                }
            }
        },
        async updateSession($origin, $initial) {

            let data = this.getSessionPayload("update");
            if($initial) {
                let policy_no_reference_point = 272437,
                policy_no_new_policy_base_padding = 2000000,
                policy_no_session_id = Number(data.id);
                data.properties.policy_no = ((policy_no_new_policy_base_padding - policy_no_reference_point) + policy_no_session_id).toString();
            }

            delete data.properties.policy_no;
            delete data.properties.session_quote_reference_id;

            
            let payload = {
                method: 'post',
                url: `${this.baseURL}/api/fdca/cfw/session/create_update.json`,
                data: data
            },
            response = await this.$store.dispatch('fetchData', payload);

            if(response.status == 200 && $initial != true) {
                localStorage.setItem("session_id", response.data.items.id);
                
                if($origin === 'registered-service') {

                    if(this.$store.state.NewBusinessHasValidNSWAddressAndAssignedToRisk) { //jump to 2nd next routes
                        this.$store.commit('mutate', {
                            property: "NewBusinessStep",
                            value: this.$store.state.NewBusinessStep + 1
                        });
                    } else {
                        this.$store.commit('mutate', {
                            property: "NewBusinessStep",
                            value: this.$store.state.NewBusinessStep + 2
                        });
                    } 

                } else {

                    this.$store.commit('mutate', {
                        property: "NewBusinessStep",
                        value: this.$store.state.NewBusinessStep + 1
                    });

                }
            }
        },
        setSessionAndQuoteDefaultValue() {

            this.$store.commit('mutate', {
                property: 'sessionDetails',
                value: {
                    id: "-1",
                    properties: {
                        user_type: '',
                        date_of_birth: null,
                        policy_id: null,
                        admin_id: null,
                        endorsement_id: null,
                        session_quote_reference_id: null,
                        seq_no: null,
                        policy_no: null,
                        member_no: null,
                        email: null,
                        pl_limit: null,
                        first_name: null,
                        last_name: null,
                        business_name: null,
                        abn: null,
                        addresses: [],
                        home_phone_number: null,
                        mobile_phone_number: null,
                        business_phone: null,
                        parent_organisation_customer: null,
                        outstanding_claims: null,
                        previous_claims: null,
                        previous_policies: null,
                        registered_for_gst: false,
                        small_business_disclaimer: null,
                        additional_cover: [],
                        additional_cover_code: '',
                        coordination_unit: null,
                        policy_premium_total: null,
                        amount_exceed_flag: null,
                        terms_agreement_flag: null,
                        last_step: null,
                        qualified_flag: null,
                        abandon_log_flag: null,
                        policy_status: "active",
                        policy_type: "Individual Educator",
                        session_status: "draft",
                        transaction_type: "New Policy",
                        amendment_description: "New Policy",
                        package: '',
                        package_code: '',
                        number_of_educators: null,
                        coverages: null,
                        scheme_coverages: null,
                        loi: null,
                        insured_name: null,
                        insured_address: {},
                        is_deleted: false,
                        evidence_of_insurance_url: null,
                        financial_services_guide_url: null,
                        letter_of_cancellation_url: null,
                        official_receipt_and_tax_invoice_url: null,
                        dual_educators: {},
                        relief_educators: [],
                        registered_service: {},
                        use_full_name_as_business_name: true,
                        interested_parties: [],
                        existing_claims: null,
                        post_all_documents: false,
                        activities: [],
                        policy_term: '12 months',
                        payment_terms: 'annual',
                        include_membership: false,
                        include_personal_accident: false,
                        additional_branches: [],
                        company_id: null,
                        customer_id: null,
                        generate_insurance_docs: false,
                        generate_membership_doc: false,
                        generate_cancellation_docs: false,
                        email_insurance_docs: false,
                        email_membership_doc: false,
                        email_cancellation_docs: false,
                        due_for_renewal: false,
                        do_not_renew: false
                    }
                }
            })
    
            this.$store.commit('mutate', {
                property: 'quoteDetails',
                value: {
                    properties: {
                        loi: null,
                        admin_fee: 0,
                        user_type: "educator",
                        session_id: null,
                        addons_base: 0,
                        addons_total: 0,
                        output_pa_uw: 0,
                        admin_fee_gst: 0,
                        dr_addon_base: 0,
                        tl_addon_base: 0,
                        non_member_fee: 0,
                        output_pa_base: 0,
                        output_pl_base: 0,
                        addons_base_gst: 0,
                        activities_count: 0,
                        ext_discount_off: null,
                        output_pa_broker: 0,
                        output_pa_uw_gst: 0,
                        output_pl_broker: 0,
                        transaction_type: null,
                        dr_addon_base_gst: 0,
                        ext_discount_code: null,
                        ext_discount_type: null,
                        flat_discount_off: null,
                        npc_discount_code: null,
                        pricing_matrix_id: null,
                        tl_addon_base_gst: 0,
                        ext_discount_value: 0,
                        flat_discount_code: null,
                        flat_discount_type: null,
                        non_member_fee_gst: 0,
                        output_pa_base_gst: 0,
                        output_pl_base_gst: 0,
                        flat_discount_value: 0,
                        npc_discount_amount: 0,
                        output_pl_qual_disc: 0,
                        npc_discount_code_yn: null,
                        output_pa_broker_gst: 0,
                        output_pa_stamp_duty: 0,
                        output_pl_broker_gst: 0,
                        output_pl_stamp_duty: 0,
                        policy_premium_total: 0,
                        activities_broker_fee: 0,
                        output_membership_base: 0,
                        activities_total_premium: 0,
                        additional_branches_base: 0,
                        activities_broker_fee_gst: 0,
                        additional_branches_broker: 0,
                        output_membership_base_gst: 0,
                        activities_prorated_premium: 0,
                        additional_branches_base_gst: 0,
                        additional_branches_total_fee: 0,
                        additional_branches_broker_gst: 0,
                        additional_branches_stamp_duty: 0
                    }
                }
            })
            
        },
        async setSessionExistingValue() {
            
            let payload = {
                method: 'get',
                url: `${this.baseURL}/main/get.json`,
                params: {
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth',
                    target: 'session',
                    id: this.sessionID
                }
            },
            response = await this.$store.dispatch('fetchData', payload);

            let value = response.data.items.results[0],
            toFormat = ['addresses', 'insured_address', 'mailing_address', 'relief_educators', 'activities', 'dual_educators', 'registered_service', 'additional_branches', 'interested_parties'];
            
            for (var key in value.properties) {
                if(toFormat.includes(key)) {
                    value.properties[key] = JSON.parse(value.properties[key]);
                }
            }
            
            if(response.data.items.results.length > 0) {
                this.$store.commit('mutate', {
                    property: "sessionDetails",
                    value: value
                });
                this.setComponentsData(response);
            } else {
                this.sessionID = null;
                localStorage.removeItem("session_id");
            }

        },
        setComponentsData($data) {
            let properties = $data.data.items.results[0].properties;
            this.setNewBusinessEducatorInformationData(properties);
            // no need to set address component data as this is fetched from sessiondetails store
            // no need to set registered service component data as this is fetched from sessiondetails store
            // no need to set gst eligibility component data as this is fetched from sessiondetails store
            // no need to set cover packages component data as this is fetched from sessiondetails store
            this.previousPolicies = properties.previous_policies;
            this.previousClaims = properties.previous_claims;
            this.existingClaims = properties.outstanding_claims;
            this.previousPoliciesAnswer = properties.previous_policies;
            this.previousClaimsAnswer = properties.previous_claims;
            this.existingClaimsAnswer = properties.outstanding_claims;
            // no need to set policy term component data as this is fetched from sessiondetails store
            this.setNewBusinessFDALegalServiceData(properties);
        },
        setNewBusinessEducatorInformationData($properties) {
            this.$refs.NewBusinessEducatorInformation.first_name = $properties.first_name;
            this.$refs.NewBusinessEducatorInformation.last_name = $properties.last_name;
            this.$refs.NewBusinessEducatorInformation.use_full_name_as_business_name = $properties.use_full_name_as_business_name;
            this.$refs.NewBusinessEducatorInformation.email = $properties.email;
            this.$refs.NewBusinessEducatorInformation.date_of_birth = $properties.date_of_birth;
            this.$refs.NewBusinessEducatorInformation.home_phone_number = $properties.home_phone_number;
            this.$refs.NewBusinessEducatorInformation.mobile_phone_number = $properties.mobile_phone_number;
        },
        setNewBusinessFDALegalServiceData($properties) {
            let self = this;
            if (!this.isInvalid($properties.additional_cover)){
                let array = $properties.additional_cover.split(",");
                array.forEach(data => {
                    data = data.replace(/\b\w/g, l => l.toUpperCase())
                    self.$refs.NewBusinessFDALegalService.selectLegalServiceOption(data);
                });
            }
        },










        async sendSummaryPayload(matrix_type, matrix_payload) {
            let matrixPayload = {   
                method: 'get',
                url: `${this.baseURL}/main/get_lookup_key.json`,
                params: {
                    token: document.getElementsByName('cmb-api-token')[0].content,
                    token_name: 'cmb-auth',
                    matrix: matrix_type,
                    payload: matrix_payload,
                    target: 'lookup_key_generate'
                }
            }
            let resp = await this.$store.dispatch('fetchData', matrixPayload);

            if(resp.status == 200 && resp.data.status !== "error") {
                
                if(matrix_type == 'add_ons') {
                    this.$store.commit('mutate', {
                        property: 'NewBusinessStoreAddonsMatrix',
                        value: resp.data.items.results[0]
                    });
                }

                if(matrix_type == 'membership') {
                    this.$store.commit('mutate', {
                        property: 'NewBusinessStoreMembershipMatrix',
                        value: resp.data.items.results[0]
                    });
                }

                if(matrix_type == 'educator_pl') {
                    this.$store.commit('mutate', {
                        property: 'NewBusinessStoreEducatorPLMatrix',
                        value: resp.data.items.results[0]
                    });
                }

                if(matrix_type == 'educator_pa') {
                    this.$store.commit('mutate', {
                        property: 'NewBusinessStoreEducatorPAMatrix',
                        value: resp.data.items.results[0]
                    });
                }

                return resp.data.items.results;
            }

        },
        async fetchSessionDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchSessionDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.state.sessionDetails = response.data.items.results[0];
                this.$store.commit('mutate', {
                    property: 'sessionDetails',
                    value: response.data.items.results[0]
                })
                this.fetchQuoteDetails();
            }
        },
        async fetchQuoteDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchQuoteDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'quoteDetails',
                    value: response.data.items.results[0]
                })
                this.fetchPreviousPolicyDetails();
            }
        },
        async fetchPreviousPolicyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchPreviousPolicyDetailsPayload);
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'previousPolicyDetails',
                    value: response.data.items.results[0]
                })
                this.paymentTerms = this.$store.state.previousPolicyDetails.properties.payment_terms;
                this.fetchCompanyDetails();
            }
        },
        async fetchCompanyDetails() {
            let response = await this.$store.dispatch('fetchData', this.fetchCompanyDetailsPayload)
            if(response.data.items.total_entries > 0) {
                this.$store.commit('mutate', {
                    property: 'companyDetails',
                    value: response.data.items.results[0]
                })
            }
        },
        previousPoliciesDeclaration($value) {
            this.previousPoliciesSubmitted = true;
            this.previousPolicies = $value;
            this.$store.commit('mutate', {
                property: 'sessionDetails.properties.previous_policies',
                value: $value
            });
            this.createUpdateSession('cover-packages-previous-policies');
        },
        previousClaimsDeclaration($value) {
            this.previousClaimsSubmitted = true;
            this.previousClaims = $value;
            this.$store.commit('mutate', {
                property: 'sessionDetails.properties.previous_claims',
                value: $value
            });

            this.createUpdateSession('cover-packages-previous-claims');
        }, 
        existingClaimsDeclaration($value) {
            this.existingClaimsSubmitted = true;
            this.existingClaims = $value;
            this.$store.commit('mutate', {
                property: 'sessionDetails.properties.existing_claims',
                value: $value
            });

            this.createUpdateSession('cover-packages-existing-claims');
        },
        nswSmallBusinessExemptionDeclaration($value) {
            this.nswSmallBusinessExemption = $value;
            this.$store.commit('mutate', {
                property: 'onlineRenewalStep',
                value: this.$store.state.onlineRenewalStep + 1
            })
        },
        
        async updatePaymentTerms($value) {
            this.$store.commit('mutate', {
                property: 'sessionDetails.properties.payment_terms',
                value: $value
            });
            this.paymentTerms = $value;

            let payload = {
                id: localStorage.getItem("session_id"),
                properties: {
                    payment_terms: $value
                }
            }

            let updateSession = await serviceModule.session.updateSession(payload);
            
        },
        purchaseRenewal() {
            this.$store.commit('mutate', {
                property: 'NewBusinessStep',
                value: this.$store.state.NewBusinessStep + 1
            })
        },
        dbToString($value) {
            return ($value / 100).toFixed(2).toString();
        },
        dbToNumber($value) {
            return Number($value / 100);
        },
        testSession() {
            const _testdata = [
                { property: "sessionDetails.properties.abn", value: "41165380085.0"},
                { property: "sessionDetails.properties.loi", value: "$20M"},
                { property: "sessionDetails.properties.email", value: "loveandmercy.fdc.nsw01@gmail.com"},
                { property: "sessionDetails.properties.seq_no", value: null },
                { property: "sessionDetails.properties.package", value: "Home Care" },
                { property: "sessionDetails.properties.admin_id", value: "0"},
                { property: "sessionDetails.properties.quote_id", value: "444956"},
                { property: "sessionDetails.properties.addresses", value: "[{\"id\":\"-1\",\"is_risk_address\":true,\"is_mailing_address\":true,\"address\":{\"address1\":\"Po Box 263\",\"address2\":\"\",\"suburb\":\"Liverpool\",\"state\":\"NSW\",\"postcode\":\"1871\",\"country\":\"Australia\"}}]"},
                { property: "sessionDetails.properties.coverages", value: "Package (PL, PA)"},
                { property: "sessionDetails.properties.last_name", value: "Osman"},
                { property: "sessionDetails.properties.member_no", value: "SA000781"},
                { property: "sessionDetails.properties.policy_id", value: null },
                { property: "sessionDetails.properties.policy_no", value: "1026031"},
                { property: "sessionDetails.properties.user_type", value: "service"},
                { property: "sessionDetails.properties.activities", value: "[{\"id\":\"0\",\"index\":0,\"activity_name\":\"asdffdas\",\"additional_information\":\"fadsfas\",\"effective_from\":\"2019-11-06\",\"effective_to\":\"2019-11-15\",\"activity_annual_premium\":\"1000\",\"activities_prorated_premium\":24.66,\"activity_broker_fee\":\"10\",\"activity_total_premium\":\"34.66\"}]"},
                { property: "sessionDetails.properties.company_id", value: "239675"},
                { property: "sessionDetails.properties.first_name", value: "Adbulaziz"},
                { property: "sessionDetails.properties.policy_term", value: "12 months"},
                { property: "sessionDetails.properties.policy_type", value: "Scheme"},
                { property: "sessionDetails.properties.do_not_renew", value: false},
                { property: "sessionDetails.properties.insured_name", value: "Adbulaziz Osman"},
                { property: "sessionDetails.properties.package_code", value: "S1"},
                { property: "sessionDetails.properties.policy_start", value: "2020-02-05"},
                { property: "sessionDetails.properties.business_name", value: "Love And Mercy Fdc Pty Ltd"},
                { property: "sessionDetails.properties.date_of_birth", value: "2019-01-01"},
                { property: "sessionDetails.properties.payment_terms", value: "annual"},
                { property: "sessionDetails.properties.policy_expiry", value: "2021-02-04"},
                { property: "sessionDetails.properties.policy_status", value: "active"},
                { property: "sessionDetails.properties.business_phone", value: null },
                { property: "sessionDetails.properties.dual_educators", value: "[{\"first_name\": \"Ellen\", \"last_name\": \"Angeli\", \"email_address\": \"ellen.angeli@outlook.com\", \"date_of_birth\": \"1967-12-19\", \"mobile_phone_number\": \"0422-815-522\", \"home_phone_number\": \"\", \"effective_from\": \"2019-02-04\", \"effective_to\": \"2020-02-03\", \"policy_no\": \" 1012669\", \"id\": \"1\", \"type\": \"dual_educator\"}]"},
                { property: "sessionDetails.properties.session_status", value: "draft"},
                { property: "sessionDetails.properties.insured_address", value: "{\"address1\": \"Po Box 263\", \"address2\": \"\", \"suburb\": \"Liverpool\", \"state\": \"NSW\", \"postcode\": \"1871\", \"country\": \"Australia\"}"},
                { property: "sessionDetails.properties.previous_claims", value: false},
                { property: "sessionDetails.properties.additional_cover", value:  null},
                { property: "sessionDetails.properties.relief_educators", value: "[{\"first_name\": \"Niamh\", \"last_name\": \"Hatherall\", \"date_of_birth\": \"1998-08-22\", \"effective_from\": \"2019-02-05\", \"effective_to\": \"2020-02-04\", \"policy_no\": \" 1007145\", \"id\": \"1\", \"type\": \"relief_educator\"}]"},
                { property: "sessionDetails.properties.scheme_coverages", value: "PL and EO"},
                { property: "sessionDetails.properties.transaction_type", value: "Renew Policy"},
                { property: "sessionDetails.properties.home_phone_number", value: "02-96017594"},
                { property: "sessionDetails.properties.previous_policies",value:  false},
                { property: "sessionDetails.properties.renewal_offer_url", value: "https://fdca-insurance.s3-ap-southeast-2.amazonaws.com/renewal-offer/renewal-offer-ZJK444955-1adb9f47-c1cb-4889-b0d5-2033cb064248.pdf"},
                { property: "sessionDetails.properties.work_phone_number",value:  null},
                { property: "sessionDetails.properties.include_membership",value:  true},
                { property: "sessionDetails.properties.interested_parties", value: "[]"},
                { property: "sessionDetails.properties.outstanding_claims",value: false},
                { property: "sessionDetails.properties.post_all_documents",value: null},
                { property: "sessionDetails.properties.previous_policy_id", value: "242577"},
                { property: "sessionDetails.properties.registered_for_gst",value: true},
                { property: "sessionDetails.properties.registered_service", value: "{\"address\": {\"address1\": \"Po Box 263\", \"address2\": \"\", \"suburb\": \"Liverpool\", \"state\": \"NSW\", \"postcode\": \"1871\", \"country\": \"Australia\"}, \"service_name\": \"Love And Mercy Fdc\", \"service_approval_number\": \"SE-40000242\"}"},
                { property: "sessionDetails.properties.additional_branches", value: "[]"},
                { property: "sessionDetails.properties.mobile_phone_number", value: "611111111111111111"},
                { property: "sessionDetails.properties.number_of_educators", value: "0-50"},
                { property: "sessionDetails.properties.policy_premium_total",value: 69500},
                { property: "sessionDetails.properties.amendment_description", value: "Accept Renewal Quote"},
                { property: "sessionDetails.properties.additional_branches_count",value: 0},
                { property: "sessionDetails.properties.include_personal_accident",value: false},
                { property: "sessionDetails.properties.small_business_disclaimer",value: true},
                { property: "sessionDetails.properties.session_quote_reference_id", value: "ZJK444955"},
                { property: "sessionDetails.properties.parent_organisation_customer",value: null },
                { property: "sessionDetails.properties.use_full_name_as_business_name",value: false}
            ];

            _testdata.forEach((d) => {
                this.commitStateValues(d.property, d.value);
            });
        },
        commitStateValues(property, value) {
            this.$store.commit('mutate', {
                property: property,
                value: value
            });
        },
        getCurrentStep(){
            const businessStep = localStorage.getItem("business_step");
            if(!!businessStep){
                this.$store.commit('mutate', {
                    property: "NewBusinessStep",
                    value: businessStep
                });
            }
        }
    },
    mounted() {
        this.sessionID = localStorage.getItem("session_id");

        this.setSessionAndQuoteDefaultValue();
        if (!this.isInvalid(this.sessionID)){
            this.setSessionExistingValue();   
        }
    }
}